import { createSelector } from 'reselect';

import { IAnalyticsExtraOfferIds } from '../../types/analytics';

import { selectAnalyticsFormId } from './selectAnalyticsFormId';
import { selectOfferId } from '../offer';

export const selectAnalyticsExtraOfferIds = createSelector(
  [selectAnalyticsFormId, selectOfferId],
  (form_id, offer_id): IAnalyticsExtraOfferIds => ({ form_id, offer_id }),
);
